/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Inbound_Issue_Too_ManyInputs */

const en_inbound_issue_too_many = /** @type {(inputs: Inbound_Issue_Too_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`too many documents for one inbound`)
};

/**
* | output |
* | --- |
* | "too many documents for one inbound" |
*
* @param {Inbound_Issue_Too_ManyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const inbound_issue_too_many = /** @type {((inputs?: Inbound_Issue_Too_ManyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Inbound_Issue_Too_ManyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_inbound_issue_too_many(inputs)
});